import { BaseConnector } from './baseConnector';

class VersionConnector extends BaseConnector {
  getVersion() {
    const url = `${this.baseApiUrl}/version`;
    return this.fetch(url);
  }
}

export { VersionConnector };
